import script from "./BracketView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BracketView.vue?vue&type=script&lang=ts&setup=true"

import "./BracketView.vue?vue&type=style&index=0&id=06b7fddd&lang=css"

const __exports__ = script;

export default __exports__